export function getValue(data) {
  if (!Array.isArray(data)) return data;
  const [first, second] = data;
  if (first === "" && second === "") return "";
  if (first === "") return `0 / ${second}`;
  if (second === "") return `${first} / 0`;
  return `${first} / ${second}`;
}

export function tranformResultsForTaka41(data) {
  const result = cleanData(data);

  const newResult = {
    Supplier: [],
    "Manufacturing step": [],
    "Manufacturing site": [],
    "Unit of measure": [],
    "ADV Item Number": [],
    Units: [],
    "Value (Single unit)": [],
    "Value (Total)": [],
    "Data source": [],
  };
  newResult["Supplier"] = result["Supplier"];
  newResult["Manufacturing step"] = result["Manufacturing step"];
  newResult["Manufacturing site"] = result["Manufacturing site"];
  newResult["Unit of measure"] = result["Unit of measure"];
  newResult["ADV Item Number"] = result["ADV Item Number"];
  newResult.Units = result["Units"].map((v) => {
    if (v.includes("/")) {
      return getValue(v.split("/").map((val) => val.trim()));
    }
    return v;
  });
  newResult["Value (Single unit)"] = result["Value (Single unit)"].map((v) => {
    if (v.includes("/")) {
      return getValue(v.split("/").map((val) => val.trim()));
    }
    return v;
  });
  newResult["Value (Total)"] = result["Value (Total)"].map((v) => {
    if (v.includes("/")) {
      return getValue(v.split("/").map((val) => val.trim()));
    }
    return v;
  });
  newResult["Data source"] = result["Data source"];
  return newResult;
}

export const getSubstrate = (advId) => {
  if (advId?.endsWith("RMN") && advId?.includes("NA")) {
    return "NA-RMN";
  }
  if (advId?.endsWith("RMN") && advId?.includes("SA")) {
    return "SA-RMN";
  }
  if (advId?.endsWith("RMN") && advId?.includes("NC")) {
    return "NC-RMN";
  }
  if (advId?.endsWith("RMN") && advId?.includes("SC")) {
    return "SC-RMN";
  }
  if (advId?.includes("NA")) {
    return "NA";
  }
  if (advId?.includes("SA")) {
    return "SA";
  }
  if (advId?.includes("NC")) {
    return "NC";
  }
  if (advId?.includes("SC")) {
    return "SC";
  }
  return "";
};

export function cleanData(tableList) {
  const stageMap = new Map();

  for (let i = 0; i < tableList["ADV Item Number"].length; i++) {
    const substrateUsed = getSubstrate(tableList["ADV Item Number"][i]);
    const stage =
      tableList["Manufacturing step"][i] +
      (substrateUsed ? ` (${substrateUsed})` : "");

    if (!stageMap.has(stage)) {
      stageMap.set(stage, createInitialStageData(tableList, i));
    } else {
      updateStageData(stageMap.get(stage), tableList, i);
    }
  }

  return buildResultFromStageMap(stageMap);
}

function createInitialStageData(tableList, index) {
  return {
    Supplier: [tableList["Supplier"][index]],
    "Manufacturing step": tableList["Manufacturing step"][index],
    "Manufacturing site": tableList["Manufacturing site"][index],
    "Unit of measure": tableList["Unit of measure"][index],
    "ADV Item Number": [tableList["ADV Item Number"][index]],
    Units: [tableList["Units"][index]],
    "Value (Single unit)": [tableList["Value (Single unit)"][index]],
    "Value (Total)": [tableList["Value (Total)"][index]],
    "Data source": tableList["Data source"][index],
  };
}

function updateStageData(existing, tableList, index) {
  existing["ADV Item Number"].push(tableList["ADV Item Number"][index]);
  existing["Units"].push(tableList["Units"][index]);
  existing["Value (Single unit)"].push(tableList["Value (Single unit)"][index]);
  existing["Value (Total)"].push(tableList["Value (Total)"][index]);
  existing["Data source"].push(tableList["Data source"][index]);
}

function buildResultFromStageMap(stageMap) {
  const newTablist = {
    Supplier: [],
    "Manufacturing step": [],
    "Manufacturing site": [],
    "Unit of measure": [],
    "ADV Item Number": [],
    Units: [],
    "Value (Single unit)": [],
    "Value (Total)": [],
    "Data source": [],
  };

  for (let [key, value] of stageMap) {
    newTablist["Supplier"] = [...newTablist["Supplier"], ...value["Supplier"]];
    newTablist["Manufacturing step"].push(key);
    newTablist["Manufacturing site"].push(value["Manufacturing site"]);
    newTablist["Unit of measure"].push(value["Unit of measure"]);
    newTablist["ADV Item Number"].push(value["ADV Item Number"].join(" OR "));

    processArrayField(newTablist["Units"], value["Units"], " / ");
    processArrayField(
      newTablist["Value (Single unit)"],
      value["Value (Single unit)"],
      " / "
    );
    processArrayField(
      newTablist["Value (Total)"],
      value["Value (Total)"],
      " / "
    );

    newTablist["Data source"].push(
      Array.isArray(value["Data source"][0])
        ? value["Data source"]
        : [value["Data source"]]
    );
  }

  return newTablist;
}

function processArrayField(targetArray, sourceArray, separator) {
  if (sourceArray.length > 1) {
    targetArray.push(sourceArray.join(separator));
  } else {
    targetArray.push(...sourceArray);
  }
}

// prettier-ignore
const ADV_ID_MAPPINGS = {
  "VXT31-5000C-> VXT31-50NA0 OR VXT31-50SA0": "VXT31-5000C-> VXT31-50NA0/SA0",
  "VXT31-50NA0 OR VXT31-50SA0": "VXT31-50NA0/SA0",
  "VXT31-50NA0 OR VXT31-50SA0-> VXT31-50NA1 OR VXT31-50NA6 OR VXT31-50SA1 OR VXT31-50SA6": "VXT31-50NA0/SA0-> VXT31-50NA1/NA6/SA1/SA6",
  "VXT41-50NA0-> VXT41-50NA1 OR VXT41-50NA0-> VXT41-50NA6": "VXT41-50NA0-> VXT41-50NA1/NA6",
  "VXT41-50SA0-> VXT41-50SA1 OR VXT41-50SA0-> VXT41-50SA6": "VXT41-50SA0-> VXT41-50SA1/SA6",
  "VXT41-50NA1 OR VXT41-50NA6": "VXT41-50NA1/NA6",
  "VXT41-50SA1 OR VXT41-50SA6": "VXT41-50SA1/SA6",
  "VXT41-50NA1-RMN OR VXT41-50NA6-RMN": "VXT41-50NA1-RMN/NA6-RMN",
  "VXT41-50SA1-RMN OR VXT41-50SA6-RMN": "VXT41-50SA1-RMN/SA6-RMN",
  "VXT41-5000C-> VXT41-50NC0 OR VXT41-5000C-> VXT41-50SC0": "VXT41-5000C-> VXT41-50NC0/SC0",
  "VXT41-50NC0 OR VXT41-50SC0": "VXT41-50NC0/SC0",
  "VXT41-50NC0-> VXT41-50NC1 OR VXT41-50SC0-> VXT41-50SC1": "VXT41-50NC0/SC0-> VXT41-50NC1/SC1"
};

export function getSimplifiedAdvId(advid) {
  if (typeof advid !== "string") return advid;
  return ADV_ID_MAPPINGS[advid] || advid;
}
